import React from "react";

const TextInput = ({
  label,
  type,
  name,
  placeholder,
  error,
  register,
  onChange,
  value,
  className,
  disabled
}) => {
  return (
    <div className={`input-group ${className ? className : ""}`}>
      {label && <label>{label}</label>}
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        className={`w-full popInput ${error ? "borderRed" : ""}`}
        onChange={onChange}
        value={value}
        disabled={disabled}
        {...register(name)}
      />
      {error && <p className="error">{error.message}</p>}
    </div>
  );
};

export default TextInput;
